import { Inject, Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { IMetaInterfaces } from "@common/interfaces/metaInterfaces";
import { Topics } from "@common/interfaces/topics";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { STORAGE_INFO_KEY } from "@ep-om/app.initializer";
import { LocalStorageService } from "@ep-om/project/service/localstorage.service";
import { canRuntimePersist } from '@persistence/session-cache';

export interface MetaInterfacesState extends EntityState<IMetaInterfaces, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.INTERFACES , realtimeEntity: 'MetaInterfaces'})
export class MetaInterfacesStore extends EntityStore<MetaInterfacesState> {

  constructor(
    private localStorage: LocalStorageService,
    @Inject(STORAGE_INFO_KEY) private storageInfoKey: string,
  ) {
    super([]);
  }

  reset(): void {
    if (canRuntimePersist()) {
      this.localStorage.set(this.storageInfoKey, []);
    }
    super.reset();
  }
}
